export default "__VITE_ASSET__BmAxDmzf__"